import { Text, Card } from '@nike/eds';
import getBondsMock from "../../mocks/getBonds.mock.json";

export type BondDetails = {
  bondNumber: string;
  bondType: string;
  suretyNumber: string;
};

export type Bond = {
  name: string;
  bondDetails: BondDetails;
};


const useBondsApi = () => {
  return { data: { items: getBondsMock.data?.getBonds?.items || [] }, isLoading: false };
};

export function BondCard({ bond }: { bond: Bond }) {
  return (
    <Card padding={24}>
      <Text font={'title-5'} as={'h2'}>{bond.name}</Text>
      <Text font={'subtitle-2'} as={'h3'}>Bond Details</Text>
      <Text font={'body-2'} as={'p'}><strong>Bond Number:</strong> {bond.bondDetails.bondNumber}</Text>
      <Text font={'body-2'} as={'p'}><strong>Bond Type:</strong> {bond.bondDetails.bondType}</Text>
      <Text font={'body-2'} as={'p'}><strong>Surety Number:</strong> {bond.bondDetails.suretyNumber}</Text>
    </Card>
  );
}

export function Bonds() {
  const { data, isLoading } = useBondsApi();

  return (
    <div className="eds-spacing--mb-24">
      <Text
        className="eds-spacing--mb-8"
        font={'title-3'}
        as={'h2'}
      >
        Bonds
      </Text>
      {isLoading && <Text>Loading bonds...</Text>}
      <div className="eds-flex eds-gap--16">
        {(data?.items || []).map((bond: Bond, idx: number) => (
          <BondCard key={idx} bond={bond} />
        ))}
      </div>
    </div>
  );
}
